import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type SubSideNavItemLabelProps = ComponentPropsWithoutRef<'span'>;

export const SubSideNavItemLabel = memo(({ className, ...restOfProps }: SubSideNavItemLabelProps) => {
  return <span className={cn('min-w-0 flex-1 truncate', className)} {...restOfProps} />;
});

SubSideNavItemLabel.displayName = 'SubSideNavItemLabel';
